import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { DoorActionComponent } from './doorAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'door-action-second',
    templateUrl:'doorActionSecond.html'
})
export class DoorActionSecondComponent extends DoorActionComponent{

  public level=2;


  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/doorActionSecond.ts